import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createRef, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Card from "@tekion/tekion-components/src/molecules/Card";
import Checkbox from "@tekion/tekion-components/src/atoms/checkbox";
import FontIcon from "@tekion/tekion-components/src/atoms/FontIcon";
import Menu from "@tekion/tekion-components/src/molecules/Menu";
import Input from "@tekion/tekion-components/src/atoms/Input";
import Dropdown from "@tekion/tekion-components/src/molecules/DropDown";
import { EMPTY_OBJECT } from "@tekion/tekion-base/app.constants";
import ConfirmationDialog from "../ConfirmationDialog";
import ColorPicker from "../ColorPicker";
import styles from "./Todo.module.scss";
import DivEditable from "../DivEditable";
import { EMPTY_STRING, NO_OP } from "../../../constants/Constants";
import { deepClone, getSafeTargetChecked, getSafeTargetValue, isEmpty } from "../../../utils/helper";
import { SIZES } from "@tekion/tekion-components/src/atoms/FontIcon";
import Favourites from "../Favourites";
const TODO_OBJECT = key => ({
  id: key,
  checked: false,
  item: EMPTY_STRING
});
const TodoItem = _ref => {
  let {
    event,
    removeEvent,
    updateEvent,
    showHeader,
    showColor,
    okButton,
    defaultEventColor,
    idKey,
    itemIdKey,
    SubHeader,
    showFavourite,
    RightHeaderAddOn
  } = _ref;
  const [title, setTitle] = useState(EMPTY_STRING);
  const [isTitleEmpty, setIsTitleEmpty] = useState(true);
  const [color, setColorCode] = useState(defaultEventColor);
  const [todoList, setTodoList] = useState({
    new: _objectSpread({}, TODO_OBJECT("new"))
  });
  const [todoKeys, setTodoKeys] = useState(["new"]);
  const [isFavourite, setIsFavourite] = useState(event.is_favourite || 0);
  const [isEdited, setIsEdited] = useState(false);
  const wrapperRef = useRef(null);
  const [deleteNotesModalVisiblity, setDeleteNotesModalVisiblity] = useState(false);
  const [focusIndex, setFocusIndex] = useState(-1);
  const randomIndexRef = useRef(Math.floor(Math.random() * 1000 + 1));
  const [divElement, setDivelementRefs] = useState([]);
  const [lastUpdatedIndex, setLastUpdatedIndex] = useState('');
  const [offshoreData, setOffshoreData] = useState({});
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(clickEvent) {
        if (ref.current && !ref.current.contains(clickEvent.target) && isEdited && clickEvent.target.id !== "delete") {
          saveEvent(clickEvent);
          setIsEdited(false);
        }
      }
      function escFunction(escKeyEvent) {
        if (escKeyEvent.key === "Escape" && isEmpty(title) && !isEmpty(todoList)) {
          deleteEvent();
          setIsEdited(false);
        }
      }
      document.addEventListener("keydown", escFunction, false);
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", escFunction, false);
      };
    }, [wrapperRef, title, todoList, isEdited, lastUpdatedIndex]);
  }
  const saveUnsavedEvent = () => {
    if (isEdited && (!isEmptyItem || !isEmpty(title))) {
      saveEvent();
    }
    setIsEdited(false);
  };
  useEffect(() => () => {
    saveUnsavedEvent();
  }, []);
  useEffect(() => {
    if (!isEmpty(event === null || event === void 0 ? void 0 : event.title) || !isEmpty(event === null || event === void 0 ? void 0 : event.todoList)) {
      setTitle(event === null || event === void 0 ? void 0 : event.title);
      if (!isEmpty(event === null || event === void 0 ? void 0 : event.title)) {
        setIsTitleEmpty(false);
      }
      setTodoListObjects(deepClone(event === null || event === void 0 ? void 0 : event.todoList));
      setColorCode(event === null || event === void 0 ? void 0 : event.color);
      if (isEmpty(event === null || event === void 0 ? void 0 : event.todoList)) {
        const newKey = "new-".concat(randomNumberGenerator());
        setTodoList({
          [newKey]: _objectSpread({}, TODO_OBJECT("".concat(newKey)))
        });
        setTodoKeys([newKey]);
      }
    }
  }, [event]);
  useEffect(() => {
    setDivelementRefs(elRefs => Array(Object.keys(todoList).length).fill().map((_, i) => elRefs[i] || /*#__PURE__*/createRef()));
  }, [Object.keys(todoList).length]);
  useEffect(() => {
    if (!isEmpty(todoList)) {
      const el = document.getElementById(todoKeys[focusIndex]);
      const selection = window.getSelection();
      if (!isEmpty(el)) {
        const range = document.createRange();
        selection.removeAllRanges();
        range.selectNodeContents(el);
        range.collapse(false);
        selection.addRange(range);
        el.focus();
        el.scrollIntoView({
          block: 'nearest',
          inline: 'start'
        });
      }
    }
  }, [focusIndex, divElement]);
  useOutsideAlerter(wrapperRef);
  const setTodoListObjects = todoLists => {
    let arrayOftodo = {};
    todoLists.forEach((todo, index) => {
      const todoObj = {
        [isEmpty(todo[itemIdKey]) ? index : todo[itemIdKey]]: _objectSpread({}, todo)
      };
      arrayOftodo = _objectSpread(_objectSpread({}, arrayOftodo), todoObj);
    });
    setTodoList(arrayOftodo);
    setTodoKeys(Object.keys(arrayOftodo));
  };
  const addTodo = index => {
    const newKey = "new-".concat(randomNumberGenerator());
    const updatedTodo = _objectSpread(_objectSpread({}, todoList), {}, {
      [newKey]: _objectSpread({}, TODO_OBJECT("".concat(newKey)))
    });
    const updatedTodoKeys = [...todoKeys];
    updatedTodoKeys.splice(todoKeys.indexOf(index) + 1, 0, newKey);
    setTodoKeys(updatedTodoKeys);
    setLastUpdatedIndex(newKey);
    randomIndexRef.current = randomNumberGenerator();
    setTodoList(updatedTodo);
    setFocusIndex(updatedTodoKeys.indexOf(newKey));
  };
  const removeTodo = index => {
    const updatedTodoKeys = [...todoKeys];
    if (updatedTodoKeys.length > 1) {
      updatedTodoKeys.splice(todoKeys.indexOf(index), 1);
      const todoListCopy = _objectSpread({}, todoList);
      delete todoListCopy[index];
      setTodoList(todoListCopy);
      setTodoKeys(updatedTodoKeys);
      randomIndexRef.current = randomNumberGenerator();
      setEdited();
    }
  };
  const updateLastUpdatedRef = id => {
    setLastUpdatedIndex(id);
    setIsEdited(true);
  };
  const onCheck = (value, i) => {
    const newTodos = _objectSpread({}, todoList);
    newTodos[i].checked = value;
    setTodoList(newTodos);
    setEdited();
  };
  const getTodoListWithOutNullValues = todoListWithNull => {
    let todoKeyValuePair = {};
    todoKeys.forEach(id => {
      var _todoListWithNull$id;
      if (!isEmpty((_todoListWithNull$id = todoListWithNull[id]) === null || _todoListWithNull$id === void 0 ? void 0 : _todoListWithNull$id.item)) {
        const todoObj = {
          [id]: {
            id,
            item: todoListWithNull[id].item,
            checked: todoListWithNull[id].checked
          }
        };
        todoKeyValuePair = _objectSpread(_objectSpread({}, todoKeyValuePair), todoObj);
      }
    });
    return todoKeyValuePair;
  };
  const saveEvent = e => {
    if (!isEmpty(e)) {
      e.stopPropagation();
    }
    let updatedTodoList = _objectSpread({}, todoList);
    if (!isEmpty(lastUpdatedIndex)) {
      var _updatedTodoList$last, _document$getElementB;
      const prevValueOfLastUpdatedIndex = (_updatedTodoList$last = updatedTodoList[lastUpdatedIndex]) === null || _updatedTodoList$last === void 0 ? void 0 : _updatedTodoList$last.item;
      const actualValue = (_document$getElementB = document.getElementById(lastUpdatedIndex)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.textContent;
      if (prevValueOfLastUpdatedIndex !== actualValue) {
        updatedTodoList = _objectSpread(_objectSpread({}, updatedTodoList), {}, {
          [lastUpdatedIndex]: _objectSpread(_objectSpread({}, updatedTodoList[lastUpdatedIndex]), {}, {
            item: isEmpty(actualValue) ? '' : actualValue
          })
        });
      }
    }
    updatedTodoList = getTodoListWithOutNullValues(updatedTodoList);
    const newKey = "new-".concat(randomNumberGenerator());
    setTodoKeys(Object.keys(updatedTodoList));
    setTodoList(isEmpty(updatedTodoList) ? {
      [newKey]: _objectSpread({}, TODO_OBJECT("".concat(newKey)))
    } : updatedTodoList);
    updateEvent(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      [idKey]: event[idKey]
    }, showHeader && {
      title: isEmpty(title) ? updatedTodoList[todoKeys[0]].item : title
    }), {}, {
      todoList: constructArrayOfTodo(updatedTodoList)
    }, showColor && {
      color
    }), showFavourite && {
      is_favourite: isFavourite
    }), offshoreData), idKey, itemIdKey);
  };
  const deleteEvent = () => {
    setDeleteNotesModalVisiblity(false);
    removeEvent(event[idKey]);
  };
  const setEdited = () => {
    if (!isEdited) {
      setIsEdited(true);
    }
  };
  const onItemChange = (value, i) => {
    var _todoList$i;
    if (((_todoList$i = todoList[i]) === null || _todoList$i === void 0 ? void 0 : _todoList$i.item) !== value) {
      setEdited();
    }
    if (isTitleEmpty && todoKeys.indexOf(i) === 0) {
      setTitle(value);
    }
    const updatedTodoList = _objectSpread({}, todoList);
    if (!isEmpty(updatedTodoList[i])) {
      updatedTodoList[i].item = value;
      const newKey = "new-".concat(randomNumberGenerator());
      setTodoList(isEmpty(updatedTodoList) ? {
        [newKey]: _objectSpread({}, TODO_OBJECT("".concat(newKey)))
      } : updatedTodoList);
    }
  };
  const enterPressed = index => {
    if (!isEmptyItem() || isNewTodo()) {
      addTodo(index);
    }
  };
  const updateTodoOnlyIfEmpty = (event, index) => {
    if (isEmpty(event.currentTarget.textContent)) {
      let updatedTodoList = _objectSpread({}, todoList);
      if (!isEmpty(updatedTodoList[index])) {
        updatedTodoList[index].item = EMPTY_STRING;
        setTodoList(updatedTodoList);
      }
    }
  };
  const onBackSpacePressed = index => {
    var _document$getElementB2;
    if (isEmpty((_document$getElementB2 = document.getElementById(index)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.textContent) && todoKeys.length !== 1) {
      setFocusIndex(todoKeys.indexOf(index) - 1);
      let updatedTodoList = _objectSpread({}, todoList);
      updatedTodoList = getTodoListWithOutNullValues(updatedTodoList);
      const newKey = "new-".concat(randomNumberGenerator());
      setTodoKeys(todoKeys.filter(todoKey => todoKey !== index));
      setTodoList(isEmpty(updatedTodoList) ? {
        [newKey]: _objectSpread({}, TODO_OBJECT("".concat(newKey)))
      } : updatedTodoList);
    }
  };
  const randomNumberGenerator = () => Math.floor(Math.random() * 1000);
  const isEmptyItem = () => {
    const emptyTodoListKeys = [];
    Object.keys(todoList).forEach(id => {
      var _document$getElementB3;
      if (!isEmpty(document.getElementById(id)) && isEmpty((_document$getElementB3 = document.getElementById(id)) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.textContent)) {
        emptyTodoListKeys.push(id);
      }
    });
    return !isEmpty(emptyTodoListKeys);
  };
  const isNewTodo = () => {
    var _document$getElementB4;
    if (!isEmpty(lastUpdatedIndex) && lastUpdatedIndex.startsWith('new') && !isEmpty((_document$getElementB4 = document.getElementById(lastUpdatedIndex)) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.textContent)) {
      return true;
    }
    return false;
  };
  const constructArrayOfTodo = todoListToProcess => {
    const arrayOfTodos = [];
    todoKeys.forEach(id => {
      if (!isEmpty(todoListToProcess[id])) {
        arrayOfTodos.push(todoListToProcess[id]);
      }
    });
    return arrayOfTodos;
  };
  const saveColor = colorCode => {
    setColorCode(colorCode);
    const updatedTodoList = getTodoListWithOutNullValues(todoList);
    updateEvent(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      [idKey]: event[idKey]
    }, showHeader && {
      title: isEmpty(title) ? updatedTodoList[todoKeys[0]].item : title
    }), {}, {
      todoList: constructArrayOfTodo(updatedTodoList)
    }, showColor && {
      color: colorCode
    }), showFavourite && {
      is_favourite: isFavourite
    }), offshoreData), idKey, itemIdKey);
  };
  const handleFavIconClick = () => {
    setIsFavourite(isFavourite === 1 ? 0 : 1);
    updateEvent(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      [idKey]: event[idKey]
    }, showHeader && {
      title: isEmpty(title) ? todoList[todoKeys[0]].item : title
    }), {}, {
      todoList: constructArrayOfTodo(getTodoListWithOutNullValues(todoList))
    }, showColor && {
      color
    }), showFavourite && {
      is_favourite: isFavourite === 1 ? 0 : 1
    }), offshoreData), idKey, itemIdKey);
    setIsEdited(false);
  };
  const offshoreUpdate = (addOnObj, isInitialValue) => {
    setOffshoreData(_objectSpread(_objectSpread({}, offshoreData), addOnObj));
    if (!isInitialValue) {
      const updatedTodoList = getTodoListWithOutNullValues(todoList);
      updateEvent(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
        [idKey]: event[idKey]
      }, showHeader && {
        title
      }), {}, {
        todoList: constructArrayOfTodo(updatedTodoList)
      }, showColor && {
        color
      }), showFavourite && {
        is_favourite: isFavourite
      }), offshoreData), addOnObj), idKey, itemIdKey);
      setIsEdited(false);
    }
  };
  const onKeyPress = (e, index) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      enterPressed(index);
    }
    if (e.keyCode === 8) {
      onBackSpacePressed(index);
    }
  };
  const onContentChange = (e, index) => {
    onItemChange(e.currentTarget.textContent, index);
  };
  const renderTodo = (todo, index, elementIndex) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: styles.todoItem
  }, /*#__PURE__*/React.createElement(Checkbox, {
    key: "index".concat(index + 1),
    checked: todo === null || todo === void 0 ? void 0 : todo.checked,
    disabled: isEmpty(todo === null || todo === void 0 ? void 0 : todo.item),
    onChange: e => onCheck(getSafeTargetChecked(e), index)
  }), /*#__PURE__*/React.createElement(DivEditable, {
    className: styles.todoContent,
    divElementRef: divElement[elementIndex],
    focusIndex: focusIndex,
    html: todo === null || todo === void 0 ? void 0 : todo.item,
    index: index,
    isChecked: todo === null || todo === void 0 ? void 0 : todo.checked,
    setIsEdited: setIsEdited,
    onChange: onContentChange,
    onKeyDown: e => onKeyPress(e, index),
    updateLastUpdatedRef: updateLastUpdatedRef,
    updateTodoOnlyIfEmpty: updateTodoOnlyIfEmpty
  }), (todo === null || todo === void 0 ? void 0 : todo.item.length) > 0 && /*#__PURE__*/React.createElement(FontIcon, {
    className: styles.deleteIcon,
    size: SIZES.S,
    onClick: () => removeTodo(index)
  }, "icon-trash"));
  const checkIfTitleIsEmpty = e => {
    if (!isEmpty(getSafeTargetValue(e)) && isTitleEmpty) {
      setIsTitleEmpty(false);
    }
    if (isEmpty(e.target.value) && !isTitleEmpty) {
      setIsTitleEmpty(true);
    }
  };
  const onChangeHeaderTitle = e => {
    setTitle(getSafeTargetValue(e));
    setEdited();
    checkIfTitleIsEmpty(e);
  };
  const renderHeader = () => /*#__PURE__*/React.createElement("div", {
    className: styles.todoHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.titleGroup
  }, showFavourite ? /*#__PURE__*/React.createElement(Favourites, {
    isSelected: isFavourite === 1,
    onClick: handleFavIconClick
  }) : /*#__PURE__*/React.createElement(FontIcon, {
    size: SIZES.L,
    className: styles.eventTitle
  }, "tap-icon-check-circle"), /*#__PURE__*/React.createElement(Input, {
    input: true,
    className: styles.titleStyle,
    inputContainerClass: styles.todoTitle,
    inputWrapperClass: styles.noBorder,
    placeholder: __("Untitled"),
    type: "text",
    value: title,
    onChange: onChangeHeaderTitle
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.todoRightHeader
  }, !isEmpty(RightHeaderAddOn) && /*#__PURE__*/React.createElement(RightHeaderAddOn, {
    offshoreUpdate: offshoreUpdate,
    offshoreData: offshoreData
  }), /*#__PURE__*/React.createElement(Dropdown, {
    overlay: renderEventOption(),
    placement: "bottomLeft"
  }, /*#__PURE__*/React.createElement(FontIcon, {
    className: styles.eventOption
  }, "tap-icon-ellipsis"))));
  const renderConfirmationDialog = () => /*#__PURE__*/React.createElement(ConfirmationDialog, {
    bodyMessage: __("Are you sure want to delete todo ?"),
    okButtonProps: _objectSpread(_objectSpread({}, okButton), {}, {
      id: "delete"
    }),
    submitBtnText: __("Delete"),
    title: __("Delete Todo"),
    visible: deleteNotesModalVisiblity,
    onCancel: () => {
      setDeleteNotesModalVisiblity(false);
    },
    onSubmit: deleteEvent
  });
  const renderEventOption = () => /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(Menu.Item, null, /*#__PURE__*/React.createElement("div", {
    className: styles.label,
    id: "delete",
    role: "button",
    tabIndex: "0",
    onClick: () => setDeleteNotesModalVisiblity(true)
  }, __("Delete"))));
  return /*#__PURE__*/React.createElement(Card, {
    className: styles.todoEvent
  }, showColor && /*#__PURE__*/React.createElement(ColorPicker, {
    colorPickerClassName: styles.coloredOption,
    selectedColor: color,
    title: __("Select color"),
    onSelectColor: _ref2 => {
      let {
        colorCode
      } = _ref2;
      return saveColor(colorCode);
    }
  }), /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, showHeader && renderHeader(), !isEmpty(SubHeader) && /*#__PURE__*/React.createElement(SubHeader, {
    offshoreUpdate: offshoreUpdate,
    offshoreData: offshoreData
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.todoList
  }, !isEmpty(todoList) && todoKeys.map((id, index) => renderTodo(todoList[id], id, index)))), deleteNotesModalVisiblity && renderConfirmationDialog());
};
export default TodoItem;
TodoItem.propTypes = {
  event: PropTypes.object,
  removeEvent: PropTypes.func,
  updateEvent: PropTypes.func,
  showHeader: PropTypes.bool,
  showColor: PropTypes.bool,
  okButton: PropTypes.object,
  defaultEventColor: PropTypes.string,
  idKey: PropTypes.string,
  itemIdKey: PropTypes.string,
  SubHeader: PropTypes.object,
  showFavourite: PropTypes.bool,
  RightHeaderAddOn: PropTypes.object
};
TodoItem.defaultProps = {
  event: EMPTY_OBJECT,
  removeEvent: NO_OP,
  updateEvent: NO_OP,
  showHeader: false,
  showColor: false,
  okButton: EMPTY_OBJECT,
  defaultEventColor: "#A1C2FF",
  idKey: 'id',
  itemIdKey: 'id',
  SubHeader: EMPTY_OBJECT,
  showFavourite: false,
  RightHeaderAddOn: EMPTY_OBJECT
};